import { createTheme, adaptV4Theme } from '@mui/material';
import { faIR } from '@mui/material/locale';
import palette from './palette';
import typography from './typography';
import overrides from './overrides';

export * from './constants';

const theme = createTheme(
  adaptV4Theme({
    palette,
    typography,
    overrides,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    direction: 'rtl',
  }),
  faIR,
  {
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            margin: 0,
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '0.875rem',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            lineHeight: 1.43,
            letterSpacing: '0.01071em',
            backgroundColor: '#fafafa',
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: ({ ownerState, theme }) => {
            const spacing = ownerState?.spacing;

            // MUI v4 split `spacing` equally around every Grid item. MUI v5
            // applies the full value only to the leading edges. All existing
            // usages in this project use numeric spacing, so restore the v4
            // gutter model without affecting grids that do not use spacing.
            if (!ownerState?.container || typeof spacing !== 'number' || spacing <= 0) {
              return {};
            }

            const gutter = theme.spacing(spacing);
            const halfGutter = theme.spacing(spacing / 2);

            return {
              width: `calc(100% + ${gutter})`,
              margin: `-${halfGutter}`,
              '& > .MuiGrid-item': {
                padding: halfGutter,
              },
            };
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            height: '1.1876em',
            padding: '6px 0 7px',
          },
        },
      },
      MuiButton: {
        // MUI v4 used `default` when color was omitted. In MUI v5 the
        // default is `primary`; `inherit` restores the neutral base variant
        // while explicit color="primary" / color="secondary" still work.
        defaultProps: {
          color: 'inherit',
        },
      },
      MuiTabScrollButton: {
        // MUI v5 renders scroll arrows for scrollable tabs. The panel did not
        // expose these controls before the migration, so keep them hidden
        // consistently across all tab lists.
        styleOverrides: {
          root: {
            display: 'none',
          },
        },
      },
      // These controls defaulted to secondary in MUI v4 and changed to
      // primary in MUI v5. Preserve the existing panel color semantics for
      // every screen unless a component explicitly requests another color.
      MuiCheckbox: {
        defaultProps: {
          color: 'secondary',
        },
      },
      MuiRadio: {
        defaultProps: {
          color: 'secondary',
        },
      },
      MuiSwitch: {
        defaultProps: {
          color: 'secondary',
        },
      },
    },
  },
);

export default theme;
